import {
  EmailSentHistoryFilters,
  EmailSentHistoryResponse,
} from '../../types/emailSentHistory/emailSentHistory.types';
import {
  GET_EMAIL_SENT_HISTORY_REQUEST,
  GET_EMAIL_SENT_HISTORY_SUCCESS,
  GET_EMAIL_SENT_HISTORY_FAILURE,
  GetEmailSentHistoryRequestAction,
  GetEmailSentHistorySuccessAction,
  GetEmailSentHistoryFailureAction,
  CLEAR_EMAIL_SENT_HISTORY_SUCCESS,
  ClearEmailSentHistorySuccessAction,
  GET_DRAFT_EMAILS_REQUEST,
  GET_DRAFT_EMAILS_SUCCESS,
  GET_DRAFT_EMAILS_FAILURE,
  GetDraftEmailsRequestAction,
  GetDraftEmailsSuccessAction,
  GetDraftEmailsFailureAction,
  CLEAR_DRAFT_EMAILS_SUCCESS,
  ClearDraftEmailsSuccessAction,
  SEND_EMAIL_REQUEST,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAILURE,
  SendEmailRequestAction,
  SendEmailSuccessAction,
  SendEmailFailureAction,
  SEND_ALL_EMAIL_REQUEST,
  SEND_ALL_EMAIL_SUCCESS,
  SEND_ALL_EMAIL_FAILURE,
  SendAllEmailRequestAction,
  SendAllEmailSuccessAction,
  SendAllEmailFailureAction,
  EXPORT_DRAFT_EMAILS_CSV_REQUEST,
  EXPORT_DRAFT_EMAILS_CSV_SUCCESS,
  EXPORT_DRAFT_EMAILS_CSV_FAILURE,
  ExportDraftEmailsCSVRequestAction,
  ExportDraftEmailsCSVSuccessAction,
  ExportDraftEmailsCSVFailureAction,
  EXPORT_SENT_EMAILS_CSV_REQUEST,
  EXPORT_SENT_EMAILS_CSV_SUCCESS,
  EXPORT_SENT_EMAILS_CSV_FAILURE,
  ExportSentEmailsCSVRequestAction,
  ExportSentEmailsCSVSuccessAction,
  ExportSentEmailsCSVFailureAction,
  CLEAR_EXPORT_DRAFT_STATE,
  CLEAR_EXPORT_SENT_STATE,
  CLEAR_SEND_TEST_EMAIL_STATE,
  CLEAR_SEND_EMAIL_STATE,
  ClearExportDraftStateAction,
  ClearExportSentStateAction,
  ClearSendTestEmailStateAction,
  ClearSendEmailStateAction,
  SEND_TEST_EMAIL_REQUEST,
  SEND_TEST_EMAIL_SUCCESS,
  SEND_TEST_EMAIL_FAILURE,
  SendTestEmailRequestAction,
  SendTestEmailSuccessAction,
  SendTestEmailFailureAction,
  GET_EMAIL_VIEW_REQUEST,
  GET_EMAIL_VIEW_SUCCESS,
  GET_EMAIL_VIEW_FAILURE,
  GetEmailViewRequestAction,
  GetEmailViewSuccessAction,
  GetEmailViewFailureAction,
} from './emailSentHistory.types';

// Get Email Sent History Actions
export const getEmailSentHistoryRequest = (
  campaignId: string,
  filters?: EmailSentHistoryFilters
): GetEmailSentHistoryRequestAction => ({
  type: GET_EMAIL_SENT_HISTORY_REQUEST,
  payload: { campaignId, filters },
});

export const getEmailSentHistorySuccess = (
  data: EmailSentHistoryResponse
): GetEmailSentHistorySuccessAction => ({
  type: GET_EMAIL_SENT_HISTORY_SUCCESS,
  payload: data,
});

export const getEmailSentHistoryFailure = (
  error: string
): GetEmailSentHistoryFailureAction => ({
  type: GET_EMAIL_SENT_HISTORY_FAILURE,
  payload: error,
});

export const clearEmailSentHistorySuccess =
  (): ClearEmailSentHistorySuccessAction => ({
    type: CLEAR_EMAIL_SENT_HISTORY_SUCCESS,
  });

// Get Draft Emails Actions
export const getDraftEmailsRequest = (
  campaignId: string,
  filters?: EmailSentHistoryFilters
): GetDraftEmailsRequestAction => ({
  type: GET_DRAFT_EMAILS_REQUEST,
  payload: { campaignId, filters },
});

export const getDraftEmailsSuccess = (
  data: EmailSentHistoryResponse
): GetDraftEmailsSuccessAction => ({
  type: GET_DRAFT_EMAILS_SUCCESS,
  payload: data,
});

export const getDraftEmailsFailure = (
  error: string
): GetDraftEmailsFailureAction => ({
  type: GET_DRAFT_EMAILS_FAILURE,
  payload: error,
});

export const clearDraftEmailsSuccess = (): ClearDraftEmailsSuccessAction => ({
  type: CLEAR_DRAFT_EMAILS_SUCCESS,
});

// Send Email Actions
export const sendEmailRequest = (emailId: string): SendEmailRequestAction => ({
  type: SEND_EMAIL_REQUEST,
  payload: { emailId },
});

export const sendEmailSuccess = (
  emailId: string,
  message: string
): SendEmailSuccessAction => ({
  type: SEND_EMAIL_SUCCESS,
  payload: { emailId, message },
});

export const sendEmailFailure = (error: string): SendEmailFailureAction => ({
  type: SEND_EMAIL_FAILURE,
  payload: error,
});

// Send All Email Actions
export const sendAllEmailRequest = (
  campaignId: string
): SendAllEmailRequestAction => ({
  type: SEND_ALL_EMAIL_REQUEST,
  payload: { campaignId },
});

export const sendAllEmailSuccess = (
  campaignId: string,
  message: string
): SendAllEmailSuccessAction => ({
  type: SEND_ALL_EMAIL_SUCCESS,
  payload: { campaignId, message },
});

export const sendAllEmailFailure = (
  error: string
): SendAllEmailFailureAction => ({
  type: SEND_ALL_EMAIL_FAILURE,
  payload: error,
});

// Export Draft Emails CSV Actions
export const exportDraftEmailsCSVRequest = (
  campaignId: string,
  startDate?: string,
  endDate?: string
): ExportDraftEmailsCSVRequestAction => ({
  type: EXPORT_DRAFT_EMAILS_CSV_REQUEST,
  payload: { campaignId, startDate, endDate },
});

export const exportDraftEmailsCSVSuccess = (
  blob: Blob
): ExportDraftEmailsCSVSuccessAction => ({
  type: EXPORT_DRAFT_EMAILS_CSV_SUCCESS,
  payload: blob,
});

export const exportDraftEmailsCSVFailure = (
  error: string
): ExportDraftEmailsCSVFailureAction => ({
  type: EXPORT_DRAFT_EMAILS_CSV_FAILURE,
  payload: error,
});

// Export Sent Emails CSV Actions
export const exportSentEmailsCSVRequest = (
  campaignId: string,
  startDate?: string,
  endDate?: string
): ExportSentEmailsCSVRequestAction => ({
  type: EXPORT_SENT_EMAILS_CSV_REQUEST,
  payload: { campaignId, startDate, endDate },
});

export const exportSentEmailsCSVSuccess = (
  blob: Blob
): ExportSentEmailsCSVSuccessAction => ({
  type: EXPORT_SENT_EMAILS_CSV_SUCCESS,
  payload: blob,
});

export const exportSentEmailsCSVFailure = (
  error: string
): ExportSentEmailsCSVFailureAction => ({
  type: EXPORT_SENT_EMAILS_CSV_FAILURE,
  payload: error,
});

// Clear Export Actions
export const clearExportDraftState = (): ClearExportDraftStateAction => ({
  type: CLEAR_EXPORT_DRAFT_STATE,
});

export const clearExportSentState = (): ClearExportSentStateAction => ({
  type: CLEAR_EXPORT_SENT_STATE,
});

export const clearSendTestEmailState = (): ClearSendTestEmailStateAction => ({
  type: CLEAR_SEND_TEST_EMAIL_STATE,
});

export const clearSendEmailState = (): ClearSendEmailStateAction => ({
  type: CLEAR_SEND_EMAIL_STATE,
});

// Send Test Email Actions
export const sendTestEmailRequest = (
  senderAccountId: string,
  emailTemplateId: string,
  contactId: string,
  emailAddress: string[]
): SendTestEmailRequestAction => ({
  type: SEND_TEST_EMAIL_REQUEST,
  payload: { senderAccountId, emailTemplateId, contactId, emailAddress },
});

export const sendTestEmailSuccess = (
  message: string
): SendTestEmailSuccessAction => ({
  type: SEND_TEST_EMAIL_SUCCESS,
  payload: { message },
});

export const sendTestEmailFailure = (
  error: string
): SendTestEmailFailureAction => ({
  type: SEND_TEST_EMAIL_FAILURE,
  payload: error,
});

// Get Email View Actions
export const getEmailViewRequest = (
  emailId: string
): GetEmailViewRequestAction => ({
  type: GET_EMAIL_VIEW_REQUEST,
  payload: { emailId },
});

export const getEmailViewSuccess = (
  message: string,
  data: any
): GetEmailViewSuccessAction => ({
  type: GET_EMAIL_VIEW_SUCCESS,
  payload: { message, data },
});

export const getEmailViewFailure = (
  error: string
): GetEmailViewFailureAction => ({
  type: GET_EMAIL_VIEW_FAILURE,
  payload: error,
});
